import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  exchangeCountFromModel,
  validateExchangeCountCondition,
  type ExchangeCountState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const EXCHANGE_COUNT = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ExchangeCountState>>,
): ConditionType<ExchangeCountState, Condition.ExchangeCount> => ({
  name: "Allowed # exchanges per item",
  description(state) {
    switch (state) {
      case undefined:
        return "The total number of exchanges allowed for each returned item. All returned items must qualify.";
      case "1":
        return "Item can be exchanged once total";
      case "2":
        return "Item can be exchanged twice total";
      default:
        return `Item can be exchanged ${+state} times total`;
    }
  },
  Details(props: ConditionTypeDetailsProps<ExchangeCountState>) {
    return React.createElement(Details, props);
  },
  empty: (1).toFixed(0),
  fromModel(model) {
    return exchangeCountFromModel(model);
  },
  toModel(state) {
    return { type: Condition.EXCHANGE_COUNT, numExchanges: +state };
  },
  valid(state) {
    return validateExchangeCountCondition(state).valid;
  },
});

export { type ExchangeCountState } from "@redotech/redo-model/return-flow/condition-validate";
